'use strict';

import ready from './lib/ready';

// utilities
import './lib/scrollbar-width';
import promiseIdle from './lib/promise-idle';
import initScrollingDown from './lib/scrolling-down';
import initSmoothScrollToAnchor from './lib/smooth-scroll-to-anchor';
import initTableOverflow from './table-overflow';
// import {initToggletips} from "./lib/Toggletip";
import './fonts';

import './tac/vimeo';
import './tac/youtube';
import './tac/googletagmanager';
import './tac/gtm-consent';
import './tac/gtm';
import './tac';

import './force-image-loading-on-print';
import './content-link-handler';
import './rolling-numbers';
import './lib/toggle-tooltip';
import initNav from './nav';
import './submenu';
import './lib/reveal';
// import './faq';
// import './hero-front-form';
import './search';

import './load';

ready().then(promiseIdle()).then(function init() {
    initScrollingDown();
    initSmoothScrollToAnchor();
    initTableOverflow('.table-wrapper__viewport,.lylan-toc__viewport');
    initNav();
});